<mat-card appearance="outlined" style="overflow-y: auto">
	<mat-card-header>
		<mat-card-title>{{ (cancelFlightMode ? 'FLIGHTS.CANCEL.title' : 'FLIGHTS.edit_wa') | translate | capitalize }}</mat-card-title>
	</mat-card-header>
	<!-- 222: the cancel message already went out (message-first) — nothing left to compose -->
	<mat-card-content *ngIf="cancelFlightMode && data.cancelFlight.alreadySent" class="mat-card-content">
		<p class="qr-cancel-note">
			<mat-icon>mark_email_read</mat-icon>
			<span>{{ 'FLIGHTS.CANCEL.already_sent' | translate | capitalize }}</span>
		</p>
		<ng-container *ngTemplateOutlet="cancelReasonRow"></ng-container>
	</mat-card-content>
	<ng-container *ngIf="!(cancelFlightMode && data.cancelFlight.alreadySent)">
	<mat-chip-set *ngIf="getNumberOfLanguages() > 1" style="margin-left: 20px">
		<mat-chip *ngIf="languages.nl > 0" [selected]="langSelected === 'nl'" (click)="updateLang('nl')">nl ({{ languages.nl }})</mat-chip>
		<mat-chip *ngIf="languages.fr > 0" [selected]="langSelected === 'fr'" (click)="updateLang('fr')">fr ({{ languages.fr }})</mat-chip>
		<mat-chip *ngIf="languages.en > 0" [selected]="langSelected === 'en'" (click)="updateLang('en')">en ({{ languages.en }})</mat-chip>
		<mat-chip *ngIf="languages.de > 0" [selected]="langSelected === 'de'" (click)="updateLang('de')">de ({{ languages.de }})</mat-chip>
	</mat-chip-set>
	<mat-card-content class="mat-card-content">
		<!-- 037 US7 (2026-09-03): conversation mode — pick the message type in the dialog itself,
		     the same pattern as the email dialog's template toggle -->
		<div *ngIf="conversationMode" style="margin-bottom: 10px">
			<mat-button-toggle-group class="type-toggle-group" name="smsType" [value]="selectedType">
				<mat-button-toggle *ngFor="let t of conversationTypes" (click)="selectType(t.type)" [value]="t.type">
					{{ t.labelKey | translate | capitalize }}
				</mat-button-toggle>
			</mat-button-toggle-group>
			<!-- 2026-09-12: flight-bound types hidden because the booking has no planned flight -->
			<p
				*ngIf="flightTypesHidden"
				style="color: #5d6c64; background: #eef4f0; border-radius: 4px; padding: 8px 12px; margin: 6px 0 0 0; display: flex; align-items: center; gap: 8px"
			>
				<mat-icon style="flex-shrink: 0">info</mat-icon>
				<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.noFlightTypesHidden' | translate }}</span>
			</p>
		</div>
		<!-- 037 FR-006c (decision 2026-08-31): outside the 24h window the APPROVED TEMPLATE is sent —
		     edits reach only in-window recipients. Three states: all-open / some-closed / edited-warning. -->
		<p
			*ngIf="cloudProvider && windowChecked && outOfWindowCount === 0"
			style="color: #12864b; background: #eef7f0; border-radius: 4px; padding: 8px 12px; display: flex; align-items: center; gap: 8px"
		>
			<mat-icon style="flex-shrink: 0">check_circle</mat-icon>
			<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.windowAllOpen' | translate }}</span>
		</p>
		<p
			*ngIf="cloudProvider && windowChecked && outOfWindowCount > 0 && !textEdited"
			style="color: #5d6c64; background: #eef4f0; border-radius: 4px; padding: 8px 12px; display: flex; align-items: center; gap: 8px"
		>
			<mat-icon style="flex-shrink: 0">info</mat-icon>
			<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.windowSomeClosed' | translate: { count: outOfWindowCount, total: recipientCount } }}</span>
		</p>
		<p
			*ngIf="cloudProvider && windowChecked && outOfWindowCount > 0 && textEdited"
			style="color: #8a5300; background: #fff3e0; border-radius: 4px; padding: 8px 12px; display: flex; align-items: center; gap: 8px; font-weight: 500"
		>
			<mat-icon style="flex-shrink: 0; color: #f57c00">warning</mat-icon>
			<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.windowEditedWarning' | translate: { count: outOfWindowCount, total: recipientCount } }}</span>
		</p>
		<p
			*ngIf="cloudProvider && !windowChecked"
			style="color: #5d6c64; background: #eef4f0; border-radius: 4px; padding: 8px 12px; display: flex; align-items: center; gap: 8px"
		>
			<mat-icon style="flex-shrink: 0">info</mat-icon>
			<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.dialogWindowNote' | translate }}</span>
		</p>
		<!-- 037 FR-029: variant picker — a message type can carry several approved wordings -->
		<mat-form-field *ngIf="templateVariants.length > 1" appearance="outline" class="full-width">
			<mat-label>{{ 'SETTINGS.VARIANTS.picker' | translate | capitalize }}</mat-label>
			<mat-select [value]="settings" (selectionChange)="selectVariant($event.value)">
				<mat-option *ngFor="let variant of templateVariants; let i = index" [value]="variant">
					{{ variant.label || ('SETTINGS.VARIANTS.variant' | translate | capitalize) + ' ' + (i + 1) }}
				</mat-option>
			</mat-select>
		</mat-form-field>
		<!-- SMS Form -->
		<form [formGroup]="waDetailForm">
			<div style="display: flex; flex-direction: column; justify-content: space-between; gap: 10px">
				<mat-form-field appearance="outline" *ngIf="langSelected === 'nl'" class="full-width">
					<mat-label *ngIf="!whatsapp?.fallbackSms">{{ 'FLIGHTS.message' | translate | capitalize }}</mat-label>
					<mat-label *ngIf="whatsapp?.fallbackSms">{{ 'FLIGHTS.message_sms_fallback' | translate | capitalize }}</mat-label>
					<textarea cdkTextareaAutosize minRows="4" matInput formControlName="smsNL"></textarea>
					<mat-icon *ngIf="imageSupported" matSuffix [matBadge]="selectedImages.length" [matBadgeHidden]="selectedImages.length === 0">
						<ng-container [ngTemplateOutlet]="imageIconTemplate"></ng-container
					></mat-icon>
				</mat-form-field>
				<mat-form-field appearance="outline" *ngIf="langSelected === 'fr'" class="full-width">
					<mat-label *ngIf="!whatsapp?.fallbackSms">{{ 'FLIGHTS.message' | translate | capitalize }}</mat-label>
					<mat-label *ngIf="whatsapp?.fallbackSms">{{ 'FLIGHTS.message_sms_fallback' | translate | capitalize }}</mat-label>
					<textarea cdkTextareaAutosize minRows="4" matInput formControlName="smsFR"></textarea>
					<mat-icon *ngIf="imageSupported" matSuffix [matBadge]="selectedImages.length" [matBadgeHidden]="selectedImages.length === 0">
						<ng-container [ngTemplateOutlet]="imageIconTemplate"></ng-container>
					</mat-icon>
				</mat-form-field>
				<mat-form-field appearance="outline" *ngIf="langSelected === 'en'" class="full-width">
					<mat-label *ngIf="!whatsapp?.fallbackSms">{{ 'FLIGHTS.message' | translate | capitalize }}</mat-label>
					<mat-label *ngIf="whatsapp?.fallbackSms">{{ 'FLIGHTS.message_sms_fallback' | translate | capitalize }}</mat-label>
					<textarea cdkTextareaAutosize minRows="4" matInput formControlName="smsEN"></textarea>
					<mat-icon *ngIf="imageSupported" matSuffix [matBadge]="selectedImages.length" [matBadgeHidden]="selectedImages.length === 0">
						<ng-container [ngTemplateOutlet]="imageIconTemplate"></ng-container
					></mat-icon>
				</mat-form-field>
				<mat-form-field appearance="outline" *ngIf="langSelected === 'de'" class="full-width">
					<mat-label *ngIf="!whatsapp?.fallbackSms">{{ 'FLIGHTS.message' | translate | capitalize }}</mat-label>
					<mat-label *ngIf="whatsapp?.fallbackSms">{{ 'FLIGHTS.message_sms_fallback' | translate | capitalize }}</mat-label>
					<textarea cdkTextareaAutosize minRows="4" matInput formControlName="smsDE"></textarea>
					<mat-icon *ngIf="imageSupported" matSuffix [matBadge]="selectedImages.length" [matBadgeHidden]="selectedImages.length === 0">
						<ng-container [ngTemplateOutlet]="imageIconTemplate"></ng-container
					></mat-icon>
				</mat-form-field>
				@if (waDetailForm.get('up').value) {
					<mat-form-field appearance="outline" style="width: 100%">
						<mat-label>UP url</mat-label>
						<textarea
							cdkAutosizeMinRows="2"
							cdkTextareaAutosize
							matInput
							disabled="true"
							[value]="('FLIGHTS.upTitle' | translate | capitalize) + '\nhttps://up.qrel.eu?...'"
						></textarea>
					</mat-form-field>
				}
				@if (waDetailForm.get('flightOptions').value) {
					<mat-form-field appearance="outline" style="width: 100%">
						<mat-label>{{ 'FLIGHTS.flightOptions' | translate | capitalize }}</mat-label>
						<textarea
							cdkAutosizeMinRows="2"
							cdkTextareaAutosize
							matInput
							disabled="true"
							[value]="'FLIGHTS.flightOptionsTitle' | translate | capitalize"
						></textarea>
					</mat-form-field>
				}
				<mat-chip-set>
					@for (chip of chipListSelected; track $index) {
						<mat-chip selected="true" (click)="chipClick(chip, langSelected)">{{ formatChip(chip) }}</mat-chip>
					}
				</mat-chip-set>
				@if (imageSupported) {
					<app-images-selector [locationId]="locationId" (selectionChanged)="onImageSelectionChanged($event)"></app-images-selector>
				}
				<!-- batch: today's rule (up enabled, not locationContactSms); conversation mode: only the
			     reservation confirmation carries the UP url / upcoming flight options (2026-09-04) -->
				<mat-slide-toggle *ngIf="showUpToggle" formControlName="up">{{
					'FLIGHTS.send_up_url_with_msg' | translate | capitalize
				}}</mat-slide-toggle>
				<mat-slide-toggle *ngIf="showFlightOptionsToggle" formControlName="flightOptions">{{
					'FLIGHTS.send_flightoptions_with_msg' | translate | capitalize
				}}</mat-slide-toggle>
				<!-- FR-006e v3 (2026-09-12): out-of-window the UP url and the flight options go as FIXED
			     platform templates (not operator-editable) — the toggles stay usable, this note says
			     what those recipients receive. -->
				<p
					*ngIf="auxAsTemplate && (showUpToggle || showFlightOptionsToggle) && (waDetailForm.value.up || waDetailForm.value.flightOptions)"
					style="color: #5d6c64; background: #eef4f0; border-radius: 4px; padding: 8px 12px; display: flex; align-items: center; gap: 8px"
				>
					<mat-icon style="flex-shrink: 0">info</mat-icon>
					<span>{{ 'COMMUNICATIONS.WHATSAPP.CLOUD.auxTemplateOutOfWindow' | translate }}</span>
				</p>
			</div>
		</form>
		<!-- 222: cancel reason — taken from the chosen message, or picked here for the general one -->
		<ng-container *ngIf="cancelFlightMode && !cancelOnlyOpen">
			<ng-container *ngTemplateOutlet="cancelReasonRow"></ng-container>
		</ng-container>
		<!-- 222: "cancel only" expands inline — no extra pop-up -->
		<div *ngIf="cancelFlightMode && cancelOnlyOpen" class="qr-cancel-only">
			<p class="qr-cancel-warning">
				<mat-icon>warning</mat-icon>
				<span>{{ 'FLIGHTS.CANCEL.cancel_only_warning' | translate | capitalize }}</span>
			</p>
			<ng-container *ngTemplateOutlet="cancelReasonRow"></ng-container>
		</div>
		<p *ngIf="sendError" class="qr-cancel-warning">
			<mat-icon>error</mat-icon>
			<span>{{ 'FLIGHTS.CANCEL.send_failed' | translate | capitalize }} ({{ sendError }})</span>
		</p>
	</mat-card-content>
	</ng-container>

	<!-- 222: cancelFlight mode actions -->
	<mat-card-actions *ngIf="cancelFlightMode" class="mat-card-actions qr-cancel-actions">
		<ng-container *ngIf="data.cancelFlight.alreadySent">
			<button mat-flat-button color="warn" (click)="cancelAlreadySent()">{{ 'FLIGHTS.MARK.CAN' | translate | capitalize }}</button>
		</ng-container>
		<ng-container *ngIf="!data.cancelFlight.alreadySent && !cancelOnlyOpen">
			<button mat-flat-button color="warn" (click)="cancelAndSend(false)" [disabled]="sending || !settings">
				<mat-spinner *ngIf="sending" diameter="18" style="display: inline-block; margin-right: 6px"></mat-spinner>
				{{ 'FLIGHTS.CANCEL.cancel_and_send' | translate | capitalize }}
			</button>
			<button *ngIf="hasCrew" mat-flat-button color="warn" (click)="cancelAndSend(true)" [disabled]="sending || !settings">
				{{ 'FLIGHTS.CANCEL.cancel_and_send_crew' | translate | capitalize }}
			</button>
			<button mat-button (click)="cancelOnlyOpen = true" [disabled]="sending">{{ 'FLIGHTS.CANCEL.cancel_only' | translate | capitalize }}</button>
		</ng-container>
		<ng-container *ngIf="!data.cancelFlight.alreadySent && cancelOnlyOpen">
			<button mat-flat-button color="warn" (click)="cancelOnly()">{{ 'FLIGHTS.CANCEL.confirm' | translate | capitalize }}</button>
			<button mat-button (click)="cancelOnlyOpen = false">{{ 'FLIGHTS.CANCEL.back' | translate | capitalize }}</button>
		</ng-container>
		<button mat-stroked-button (click)="cancel()" [disabled]="sending">{{ 'APPLICATION.cancel' | translate | capitalize }}</button>
	</mat-card-actions>

	<mat-card-actions *ngIf="!cancelFlightMode" class="mat-card-actions">
		<button mat-flat-button (click)="confirm(waDetailForm.value)" color="warn" [disabled]="sending || (conversationMode && !settings)">
			{{ 'FLIGHTS.' + sendTo | translate | capitalize }}
		</button>

		<!-- Also notify crew & pilots on cancellation (031-crew-cancel-notification) -->
		<button *ngIf="smsCancel && hasCrew" mat-flat-button (click)="confirmToAll(waDetailForm.value)" color="warn">
			{{ 'FLIGHTS.send_to_pax_and_crew' | translate | capitalize }}
		</button>

		<button mat-stroked-button (click)="cancel()">{{ 'APPLICATION.cancel' | translate | capitalize }}</button>
	</mat-card-actions>
</mat-card>

<ng-template #imageIconTemplate>
	@if (selectedImages.length === 0) {
		<span class="material-symbols-outlined"> hide_image </span>
	} @else {
		<span class="material-symbols-outlined"> image </span>
	}
</ng-template>

<!-- 222: cancel reason row (read-only from a coded message, else an optional dropdown) -->
<ng-template #cancelReasonRow>
	<div class="qr-cancel-reason-row">
		<div *ngIf="reasonFromVariant" class="qr-cancel-reason">
			<mat-icon>label</mat-icon>
			<span>{{ 'FLIGHTS.CANCEL.reason_from_message' | translate: { reason: cancelReason } | capitalize }}</span>
			<button mat-button type="button" (click)="reasonEditing = true">{{ 'FLIGHTS.CANCEL.change_reason' | translate }}</button>
		</div>
		<mat-form-field *ngIf="!reasonFromVariant" appearance="outline" class="full-width">
			<mat-label>{{ 'SETTINGS.flight.cancelReason' | translate | capitalize }}</mat-label>
			<mat-select [(value)]="cancelReason">
				<mat-option [value]="null">—</mat-option>
				<mat-option *ngFor="let reason of data.cancelFlight?.reasons || []" [value]="reason">{{ reason }}</mat-option>
				<mat-option *ngIf="cancelReason && !(data.cancelFlight?.reasons || []).includes(cancelReason)" [value]="cancelReason">{{ cancelReason }}</mat-option>
			</mat-select>
		</mat-form-field>
	</div>
</ng-template>
